
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g5j3hoDMt8CDknACkairHH_pGXWo1EHCpu_WgpS4l7lEMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexqJTpqHMDLg8f7uG7d_45b_VDc_455Y6Avl8Sp_3P7BCJl3IMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchtLU9ygXU5outUi6qnusCzKL0lIFRJW00_45VfAG71gKa8Meta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexKFJcZNxpU7H_7RJ74if7u7QtMPQV7_458KE_45UaBry5aC4Meta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93G0uigo9MZH1_45jVDAA51vcNX_45KoCqLnzCBcfJG_AQJ6YMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7uCFF33CPoqMqjzXzM8p4KGFyHAgDPmEexvZ_45tePUzAMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_933zwOH5FoTdK02_45xMkaUBdWI5t9dclC8U_ekl_45jNUVrgMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexE7P3XiEbqKJz2D6KVdPfCK_45HTJRBWS_455mETtKS9bXf0Meta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93_5fNKRLbs0dy5zO1uPsS_RXkmw_V_459TAisCJ_hpLzpkMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexJr_45k81TU_45SMF_RZnjdelU7aWuP6eGPZ8r9i3AOIheYIMeta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexnObdY1CjxZVgc4Ppo1ec3WepGCACZWIzzMPqOvd0Lg0Meta } from "/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7uCFF33CPoqMqjzXzM8p4KGFyHAgDPmEexvZ_45tePUzAMeta || {},
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexE7P3XiEbqKJz2D6KVdPfCK_45HTJRBWS_455mETtKS9bXf0Meta || {},
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexJr_45k81TU_45SMF_RZnjdelU7aWuP6eGPZ8r9i3AOIheYIMeta || {},
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexnObdY1CjxZVgc4Ppo1ec3WepGCACZWIzzMPqOvd0Lg0Meta || {},
    component: () => import("/codebuild/output/src2850199617/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]